"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectSelectedObjectsUUIDs = void 0;
/* eslint-disable import/prefer-default-export */
const reselect_1 = require("reselect");
exports.selectSelectedObjectsUUIDs = (0, reselect_1.createSelector)((state) => state.selectedObjects, (selectedObjects) => selectedObjects.selectedObjects);
